import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useServices } from "@/services-context";
import { defaultVatCoefficient, defaultVatMultiplier } from "@/constants/vat";

export interface VatNotifyProps {
  className?: string;
}

const VatNotify: React.FC<VatNotifyProps> = ({ className }) => {
  const { t } = useTranslation();
  const services = useServices();
  const customerContext = services.customerChannel;

  // SSR-safe: вычисления только по данным
  const vatCoefficient = customerContext?.vatCoefficient ?? 0;

  const percent = (vatCoefficient % defaultVatCoefficient) / defaultVatMultiplier;

  if (!percent) return <></>;

  return (
    <div className={classNames(styles.root, className)}>
      {t("9hkouimd77ty1706.vat-include", "Include {{percent}}% VAT", {
        percent,
      })}
    </div>
  );
};

export default VatNotify;
